<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid gap-4"
                            :class="[
                                loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-3' : 'md:grid-cols-2',
                            ]">
                            <el-form-item class="no-margin"
                                v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="カテゴリ名">
                                    <el-input v-model="searchForm.category_name" placeholder="カテゴリ名を入力" />
                                </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24 ml-3" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin"
                                    v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="カテゴリ名">
                                        <el-input v-model="searchForm.category_name" placeholder="カテゴリ名を入力" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn md:hidden" type="info"
                        @click="handleAddButton" circle>
                        <span class="material-symbols-outlined">
                            add
                        </span>
                    </el-button>
                    <el-button class="hidden md:block w-24" type="info"
                        @click="handleAddButton">新規登録</el-button>

                    
                    <el-upload v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" class="" ref="upload" :on-change="handleImportButton" :auto-upload="false"
                        :show-file-list="false" accept=".csv">
                        <el-tooltip content="CSVインポート" placement="top">
                            <el-button class="custom-icon-btn mx-3" type="info" circle>
                                <span class="material-symbols-outlined">
                                    upload_2
                            </span>
                        </el-button>
                        </el-tooltip>
                    </el-upload>

                    <el-button class="custom-icon-btn" type="info" 
                        @click="handleExportButton" circle>
                        <el-tooltip content="CSVエクスポート" placement="top">
                            <span class="material-symbols-outlined">
                                download_2
                            </span>
                        </el-tooltip>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>カテゴリマスタ（カテゴリ名）</span>
                    <div class="ml-auto">
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('name')"
                                :class="['mobile-sort-btn', sortField === 'name' ? 'active' : '']">
                                カテゴリ名    
                            </el-button>
                            <span>アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </div>
                </div>
                
                <div style="height: calc(100vh - 227px); overflow-y: auto;">
                    <el-card style="border: 1px solid #d1d5db; border-radius: 0px"
                        v-for="item in mTableData" :key="item.category_id">
                        <el-row align="middle">
                            <el-col :span="2">
                                <el-button
                                    class="w-8 h-16"
                                    type="info" 
                                    style="background-color: #b7b7b7;"
                                    text
                                    bg
                                    @click="handleEditButton(item)">
                                    <span>詳<br>細</span>
                                </el-button>
                            </el-col>

                            <el-col :span="18" class="ml-2">
                                <div v-if="loginUserRole === ROLES.SYSTEM">{{ item.organization_name }}</div>
                                <div>{{ item.name }}</div>
                            </el-col>

                            <el-col :span="2" class="ml-2" align="right">
                                <span class="material-symbols-outlined cursor-pointer"
                                    @click="handleDeleteButton(item)">
                                    delete
                                </span>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column label="カテゴリマスタ" width="130" align="center">
                        <template #default="scope">
                            <el-button
                                class="w-12"
                                type="info"
                                style="background-color: #b7b7b7;"
                                text
                                bg
                                @click="handleEditButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="category_id" label="コード">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('category_id')">
                                <span>{{ getSortLabel('category_id') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'category_id' }">
                                        {{ getSortIcon('category_id') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM" prop="organization_name" label="所属組織">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_name')">
                                <span>{{ getSortLabel('organization_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                        {{ getSortIcon('organization_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="カテゴリ名">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('name')">
                                <span>{{ getSortLabel('name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'name' }">
                                        {{ getSortIcon('name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="memo" label="メモ" />
                    <el-table-column label="削除" width="52" align="center">
                        <template #default="scope">
                            <span class="material-symbols-outlined cursor-pointer mt-2"
                                @click="handleDeleteButton(scope.row)">
                                delete
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handlePageChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                    @current-change="handlePageChange" />
                </div>
            </div>
        </el-mian>
    </el-container>


    <!-- 新規登録更新ダイアログ -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" v-model="dialogFormVisible"
        :title="form.add_update === 'add' ? '新規登録' : '詳細'" align-center>
        <el-form :model="form" :rules="rules" ref="formRef" label-width="120px">
            <el-form-item label="コード" prop="category_id">
                <el-input v-model="form.category_id" autocomplete="off" :disabled="form.add_update === 'update'"
                    placeholder="コード" />
            </el-form-item>
            <el-form-item label="所属組織" prop="organization_id" v-if="loginUserRole === ROLES.SYSTEM">
                <OrganizationSelect v-model="form.organization_id" placeholder="組織を選択" :disabled="form.add_update === 'update'" />
            </el-form-item>
            <el-form-item label="カテゴリ名" prop="name">
                <el-input v-model="form.name" autocomplete="off" placeholder="カテゴリ名" />
            </el-form-item>
            <el-form-item label="メモ" prop="memo">
                <el-input v-model="form.memo" autocomplete="off" placeholder="メモ" />
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogFormVisible = false">キャンセル</el-button>
                <el-button type="primary" @click="handleAddUpdateSubmit(formRef)">
                    {{ form.add_update === 'add' ? '登録' : '更新' }}
                </el-button>
            </div>
        </template>
    </el-dialog>

</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick } from 'vue';
import type { FormInstance, FormRules, UploadFile } from 'element-plus'
import { Delete, Edit, Search, Plus } from '@element-plus/icons-vue';
import { ErrorCode, ImportResponseData, ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { Operation, SearchRequest } from '@/components/common/request';
import router from '@/router';
import moment from 'moment';
import { ALL, CSV_MAX_SIZE, ROLES, ROUTES } from '@/config/constants';
import { sortingUtil, SortConfig } from '@/components/common/SortingUtil';

interface Category {
    add_update?: Operation,
    category_id: string,
    name: string,
    organization_id: string,
    organization_name?: string,
    memo?: string,
    created_by?: string,
    created_date?: string,
    updated_by?: string,
    updated_date?: string,
}

export default defineComponent({
    name: 'MngCategory',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        OrganizationSelect,
        Delete,
        Plus,
        Edit,
        Search,
    },
    setup() {
        const searchForm = ref<any>({
            category_name: '',
            organization_id: ALL,
        });

        const formRef = ref<FormInstance>();

        const form = ref<Category>({
            add_update: Operation.unknow,
            category_id: '',
            name: '',
            organization_id: '',
            memo: '',
        });

        const drawer = ref(false);

        const loading = ref<boolean>(true);
        const dialogFormVisible = ref(false);

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const rules: FormRules = {
            category_id: [
                { required: true, message: 'コードを入力してください', trigger: 'blur' },
                { min: 1, max: 20, message: 'コードは1〜20文字の間で入力してください', trigger: 'blur' }
            ],
            name: [
                { required: true, message: 'カテゴリー名を入力してください', trigger: 'blur' },
                { min: 2, max: 50, message: 'カテゴリー名は2〜50文字の間で入力してください', trigger: 'blur' }
            ],
            organization_id: [
                { required: true, message: '所属組織を選択してください', trigger: 'change' }
            ]
        };

        const sortConfig: SortConfig = {
            category_id: {
                label: 'コード',
                mobileLabel: 'コード',
                type: 'string',
                defaultOrder: 'asc'
            },
            organization_name: {
                label: '所属組織',
                mobileLabel: '所属組織',
                type: 'string',
                defaultOrder: 'asc'
            },
            name: {
                label: 'カテゴリ名',
                mobileLabel: 'カテゴリ名',
                type: 'string',
                defaultOrder: 'asc'
            },
        }
        
        const allCategories = ref<Category[]>([]);

        const {
            handleSort,
            getSortLabel,
            getSortIcon,
            paginatedData: mTableData,
            totalRecords: mTotalRecords,
            totalPages: mTotalPages,
            currentPage: mCurrentPage,
            pageSize: mPageSize,
            handleSizeChange,
            handlePageChange,
            showMoreDataAlert,
            sortField,
            sortOrder,
        } = sortingUtil(
            allCategories,
            sortConfig,
        );

        const loginUserRole = localStorage.getItem('role');
        const loginUserOrganizationId = localStorage.getItem('organization_id');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        /***** マウント **************************/
        onMounted(() => {
            //  如果没有信息，重新登陆
            if (!loginUserRole) {
                router.push(`/${ROUTES.LOGIN}`);
            }
            getCategoryList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;
            getCategoryList();
        }


        const handleAddButton = () => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.add,
                    category_id: '',
                    name: '',
                    organization_id: loginUserRole === ROLES.SYSTEM ? '' : (loginUserOrganizationId ?? ''),
                    memo: '',
                };
            });
        };


        const handleEditButton = (row: Category) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    add_update: Operation.update,
                    category_id: row.category_id.toString(),
                    name: row.name,
                    organization_id: row.organization_id,
                    memo: row.memo,
                };
            });
        };

        const handleDeleteButton = (row: Category) => {
            ElMessageBox.confirm('削除しますか？', '削除', {
                confirmButtonText: '削除',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                deleteCategory(row);
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleAddUpdateSubmit = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (form.value.add_update === Operation.add) {
                        addCategory();
                    } else if (form.value.add_update === Operation.update) {
                        updateCategory();
                    }
                    dialogFormVisible.value = false;
                }
            })
        }


        /***** DB 操作 **************************/
        const getCategoryList = async () => {
            try {
                loading.value = true;
                const params: SearchRequest = {
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    category_name: searchForm.value.category_name,
                };

                const res: AxiosResponse<ResponseData<Category[]>> = await axios.get('/api/categories/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data, hasMoreData } = res.data;

                    allCategories.value = data || [];
                    showMoreDataAlert(hasMoreData || false);
                } else {
                    ElMessage.error(getErrorMessage(PageType.CATEGORY, res.data.code));
                }
            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.CATEGORY));
            }finally{
                loading.value = false;
            }
        };


        const addCategory = async () => {
            try {
                const newObject = {
                    ...form.value,
                    id: form.value.category_id,
                }


                const res: AxiosResponse<ResponseData<Category>> = await axios.post('/api/categories', newObject);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getCategoryList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.CATEGORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.CATEGORY));
            }
        };


        const updateCategory = async () => {
            try {
                const newObject = {
                    ...form.value,
                    id: form.value.category_id,
                }
                const res: AxiosResponse<ResponseData<Category>> = await axios.put(`/api/categories/${newObject.id}`, newObject);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getCategoryList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.CATEGORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.CATEGORY));
            }
        };

        const deleteCategory = async (row: Category) => {
            try {
                const res: AxiosResponse<ResponseData> = await axios.delete(`/api/categories/${row.category_id}`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    getCategoryList();
                } else {
                    ElMessage.error(getErrorMessage(PageType.CATEGORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.CATEGORY));
            }
        };

        const exportCategory = async () => {
            try {
                const res: AxiosResponse<any> = await axios.post(`/api/categories/export`,{
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === undefined) {
                     // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    const blob = new Blob([bom + res.data], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'カテゴリマスタ_'+ moment(new Date().toISOString()).format('YYYYMMDDHHmmss') +'.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error('CSVエクスポート失敗しました。');
                }
            }
            catch (error) {
                ElMessage.error('CSVエクスポート失敗しました。');
            }
        };

        const handleExportButton = () => {
            ElMessageBox.confirm('カテゴリマスタをエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportCategory();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleImportButton = (file: UploadFile) => {
            if (file.raw) {
                const formData = new FormData()
                formData.append('file', file.raw)

                //文件过大 100K
                if (file.raw.size > CSV_MAX_SIZE) {
                    ElMessage.error('ファイルが大きすぎます。');
                    return;
                }
                
                loading.value = true;
                axios.post('/api/categories/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((res: AxiosResponse<ImportResponseData>) => {
                    if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                        getCategoryList();
                        ElMessage.success('CSVインポート成功');
                    }else{
                        ElMessage.error('CSVインポート失敗しました。');
                    }
                }).catch(error => {
                    ElMessage.error('CSVインポート失敗しました。');
                }).finally(() => {
                    loading.value = false;
                })
            } else {
                ElMessage.error('ファイルが無効です')
            }
        }

        return {
            loginUserRole,
            searchForm,
            form,
            loading,
            dialogFormVisible,

            mTableData,
            mTotalRecords,
            mCurrentPage,
            mPageSize,
            mTotalPages,

            size,
            disabled,
            background,
            handleSearchButton,
            handleAddButton,
            handleEditButton,
            handleDeleteButton,
            handleAddUpdateSubmit,
            handleSizeChange,
            handlePageChange,
            handleExportButton,
            handleImportButton,
            formRef,
            rules,
            ROLES,
            drawer,
            handleSort,
            getSortLabel,
            getSortIcon,
            sortField,
            sortOrder,
            loginUserRoleIsHead,
        }
    }
});
</script>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>